import { render } from "./FinancialBankAccountsTab.vue?vue&type=template&id=65f093dd&scoped=true"
import script from "./FinancialBankAccountsTab.vue?vue&type=script&lang=js"
export * from "./FinancialBankAccountsTab.vue?vue&type=script&lang=js"

import "./FinancialBankAccountsTab.vue?vue&type=style&index=0&id=65f093dd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65f093dd"]])

export default __exports__